var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.layout,{tag:"v-app",attrs:{"dir":_vm.isRTL(_vm.$i18n.locale) ? 'rtl' : 'ltr'}},[_c('v-main',[_c('router-view')],1)],1),_c('ErrorDisplayDialog',{attrs:{"dialogControls":_vm.dialogControls}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }